const s = require("./api.module.scss");

import { default as React, useEffect, useContext, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { ApplicationState } from "core/app";
import JSONPretty from "react-json-pretty";

interface OwnState {
    applicationState: ApplicationState;
    selectedEndpoint: any;
    jsonStyle: any;
}

type PageProps = OwnState & WithTranslation;

const Page = ({ t, applicationState, selectedEndpoint, jsonStyle }: PageProps) => {
    return (
        <div>
            <div className="inputlabel">Response</div>
            <JSONPretty data={selectedEndpoint.response} theme={jsonStyle}></JSONPretty>
            <div className="inputlabel">Structure of "Data"</div>
            <JSONPretty data={selectedEndpoint.dto} theme={jsonStyle}></JSONPretty>
        </div>
    );
};


export default withTranslation()(Page);
